import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#0f766e', light: '#e6f6f4', dark: '#0b5d57' },
    secondary: { main: '#14b8a6' },
    background: { default: '#f4f6f8', paper: '#ffffff' },
    text: { primary: '#17212b', secondary: '#64748b' },
    divider: '#e1e5ea',
    error: { main: '#c92a2a' },
    success: { main: '#087f5b' }
  },
  typography: {
    fontFamily: '-apple-system, "Segoe UI", Inter, Roboto, Arial, sans-serif',
    button: { textTransform: 'none', fontWeight: 700 }
  },
  shape: { borderRadius: 9 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { boxShadow: 'none', borderRadius: 9 },
        contained: { boxShadow: 'none', '&:hover': { boxShadow: 'none' } }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none', boxShadow: 'none' }
      }
    }
  }
});

export default theme;
